import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

interface RangeModel {
  numerator: { min: number; max: number }
  denominator: { min: number; max: number }
  factor: { min: number; max: number }
  variation: number
}

interface DifficultyLevelRangeMapModel {
  [key: number]: RangeModel
}

const DIFFICULTY_LEVEL_RANGE_MAP: DifficultyLevelRangeMapModel = {
  1: { numerator: { min: 1, max: 4 }, denominator: { min: 2, max: 5 }, factor: { min: 2, max: 2 }, variation: 10 },
  2: { numerator: { min: 1, max: 10 }, denominator: { min: 4, max: 10 }, factor: { min: 5, max: 5 }, variation: 20 },
  3: { numerator: { min: 1, max: 10 }, denominator: { min: 4, max: 10 }, factor: { min: 3, max: 3 }, variation: 20 },
  4: { numerator: { min: 1, max: 10 }, denominator: { min: 4, max: 10 }, factor: { min: 6, max: 10 }, variation: 30 },
}

export interface FractionExpandNumQuestionModel {
  leftNum: number
  leftDenom: number
  factor: number
  rightNum: number
  maxVariation: number
}

export function getFractionExpandNumQuestion(
  difficultyLevel: number,
  excludes?: string[],
): FractionExpandNumQuestionModel {
  const range = DIFFICULTY_LEVEL_RANGE_MAP[difficultyLevel]

  const factor = getRandomInt(range.factor.min, range.factor.max)
  const leftDenom = getRandomInt(range.denominator.min, range.denominator.max)
  const leftNum = getRandomInt(range.numerator.min, leftDenom - 1)
  const rightNum = leftNum * factor

  const key = `${factor}-${leftNum}-${leftDenom}`
  if (excludes && excludes.includes(key)) return getFractionExpandNumQuestion(difficultyLevel, excludes)

  return { leftNum, leftDenom, factor, rightNum, maxVariation: range.variation }
}
